export default __webpack_public_path__ + "locales/uk-UA/InfoPanel.json?hash=a02924f2fe369e10310a7e0486b5996d";